interface WidgetMessageEnvelope {
    channel: 'smartguide-widget';
    version: 1;
    instanceId: string;
    connectionId: string;
}

export type WidgetFullScreenMessage = WidgetMessageEnvelope & (
    | { type: 'host-init'; fullScreenSupported: boolean; fullScreen: boolean }
    | { type: 'app-ready'; dialogLabel: string }
    | { type: 'set-full-screen'; requestId: number; fullScreen: boolean }
    | { type: 'full-screen-state'; fullScreen: boolean; requestId?: number; errorCode?: 'unavailable' | 'busy' }
);

const boundedText = (value: unknown): value is string => typeof value === 'string' && value.trim().length > 0 && value.length <= 256;
const requestId = (value: unknown): value is number => typeof value === 'number' && Number.isSafeInteger(value) && value > 0;

export function parseWidgetFullScreenMessage(value: unknown): WidgetFullScreenMessage | null {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    const message = value as Record<string, unknown>;
    if (message.channel !== 'smartguide-widget' || message.version !== 1
        || !boundedText(message.instanceId) || !boundedText(message.connectionId)) return null;
    switch (message.type) {
        case 'host-init':
            if (typeof message.fullScreenSupported !== 'boolean' || typeof message.fullScreen !== 'boolean') return null;
            break;
        case 'app-ready':
            if (!boundedText(message.dialogLabel)) return null;
            break;
        case 'set-full-screen':
            if (!requestId(message.requestId) || typeof message.fullScreen !== 'boolean') return null;
            break;
        case 'full-screen-state':
            if (typeof message.fullScreen !== 'boolean'
                || (message.requestId !== undefined && !requestId(message.requestId))
                || (message.errorCode !== undefined && message.errorCode !== 'unavailable' && message.errorCode !== 'busy')) return null;
            break;
        default: return null;
    }
    return value as WidgetFullScreenMessage;
}
